import useEnv from '@/composition/env.js'

export default {
	install: (app) => {
		const env = useEnv()

		const request = async (endpoint, body) => {
			return await fetch(`https://rest.iad-05.braze.com/${endpoint}`, {
				headers: {
					Authorization: `Bearer ${env('BRAZE_API_KEY')}`,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(body),
				method: 'POST'
			})
		}

		const $appboy = {
			async userTrack(attributes) {
				return await request('users/track', {
					attributes
				})
			},

			async canvas(canvas_id, user_id, canvas_entry_properties = {}) {
				return await fetch('https://rest.iad-05.braze.com/canvas/trigger/send', {
					body: JSON.stringify({
						canvas_id,
						recipients: [
							{
								external_user_id: user_id,
								canvas_entry_properties
							}
						]
					}),
					headers: {
						Authorization: `Bearer ${env('BRAZE_CANVAS_API_TOKEN')}`,
						'Content-Type': 'application/json'
					},
					method: 'POST'
				})
			}
		}

		app.provide('appboy', $appboy)
	}
}
